import React from 'react';
import { useLanguage } from '../Context/LangContext';
import { reactLocalStorage } from 'reactjs-localstorage';
import selected from "../assets/icons/language_select.png";
import deselect from "../assets/icons/language_deselect.png";

const Language = ({ langObj }) => {
  const { language, changeLanguage } = useLanguage(); // Get the current language and changeLanguage function
  const onLanguageSelect = (lang) => {
    reactLocalStorage.set('lang','en');
    changeLanguage(lang); 
    window.location.replace("/home")
  };

  return (
    <div className="container m-w">
    <div className="columns is-mobile">
        <div className="column is-full">
            <div className="">
                <div className=" ">
                    <div className="display">
                       <div className="language-options">
            {langObj?.option?.map((option) => (
             <div
               key={option.id} // Use a unique key for each item
               className={`language-option text-lg bold ${
                 language === option.key ? 'selected' : ''
               }`} // Highlight the selected language
               onClick={() => onLanguageSelect(option.key)} // Change the language on click
             >
                <div>{language === option.key? <img src={selected} className='lang-icon' alt="selected"/>:
                <img src={deselect}  className="lang-icon" alt="deselect"/>
                }
                </div>
               <div className='lang-code'>{option.lang}</div> {/* Display the language name */}
             </div>
           ))}
         </div>
           </div>
          </div>
            </div>
        </div>
    </div>
   </div>
  )
};
export default Language;
